import { render, staticRenderFns } from "./CustomSelectBoxMultiple.vue?vue&type=template&id=3de966f4&"
import script from "./CustomSelectBoxMultiple.vue?vue&type=script&lang=js&"
export * from "./CustomSelectBoxMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports